const CODE = `
"models     viewer  elementData"  1fr
"viewpoints viewer  elementData"  1fr
/  22rem    1fr     22rem
`

const AREAS = ["models", "viewer", "elementData", "viewpoints", "viewer", "elementData"]

// Co-authored-with: Claude
export function GridHelp() {
  return (
    <div className="max-w-2xl mx-auto p-6 font-sans">
      <h1 className="text-xl font-bold mb-1">How the viewer grid layout works</h1>
      <p className="text-sm mb-4">
        Each line in the code below maps to a panel in the layout. Compare the two to see how they line up.
        For more info on CSS grid, read the{' '}
        <a
          href="https://css-tricks.com/snippets/css/complete-guide-grid/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-sky-600 underline hover:text-sky-700"
        >
          CSS-Tricks guide to CSS Grid
        </a>.
        <br /><br />
        Currently available panels:{' '}
        <b>models, viewpoints, elementData, viewer</b>.
      </p>

      <div
        className="grid gap-2 mb-4"
        style={{
          gridTemplateColumns: "1fr 2fr 1fr",
          gridTemplateRows: "minmax(70px,1fr) minmax(70px,1fr)",
          gridTemplateAreas: `"models viewer elementData" "viewpoints viewer elementData"`,
        }}
      >
        {AREAS.map((a, i) => (
          <div
            key={i}
            style={{ gridArea: a }}
            className="border-2 border-gray-300 bg-gray-700 p-3 flex items-center justify-center font-mono text-sm text-gray-200"
          >
            "{a}"
          </div>
        ))}
        <div className="text-center font-mono">22rem</div>
        <div className="text-center font-mono">1fr</div>
        <div className="text-center font-mono">22rem</div>
      </div>

      <pre className="bg-slate-800 text-gray-200 rounded-lg p-4 text-xs overflow-x-auto font-mono leading-relaxed">
        {CODE.trim()}
      </pre>
    </div>
  );
}